import {useSelector, useDispatch} from 'react-redux';

import {logout} from 'state/actions';
import {getUserInfo, isAuthenticated} from 'state/selectors';

import styles from './CernToolbar.module.scss';

export default function CernToolbar() {
  const isUserAuthenticated = useSelector(isAuthenticated);
  const userInfo = useSelector(getUserInfo);
  const dispatch = useDispatch();

  const renderName = () => {
    if (userInfo.username) {
      let name = userInfo['username'];
      if (userInfo['institute']) {
        name += ` (${userInfo['institute']})`;
      }
      return name;
    }
    return userInfo['email'];
  };

  return (
    <header className={styles.CernToolbar}>
      <h1>
        <a href="http://home.cern" title="CERN">
          CERN <span>Accelerating science</span>
        </a>
      </h1>
      <ul>
        <li className={styles.CernAccountLinks}>
          {isUserAuthenticated && userInfo ? (
            <>
              <span>
                Signed in as:{' '}
                <a href="https://cern.ch/account" className={styles.CernAccount}>
                  {renderName()}
                </a>
              </span>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className={styles.CernSignout}
                href="#"
                onClick={() => {
                  dispatch(logout());
                }}
                title="Sign out of your account"
              >
                Sign out
              </a>
            </>
          ) : (
            <a className={styles.CernAccount} href="/login" title="Sign in to your CERN account">
              Sign in
            </a>
          )}
        </li>
        <li>
          <a
            className={styles.CernDirectory}
            href="http://cern.ch/directory"
            title="Search CERN resources and browse the directory"
          >
            Directory
          </a>
        </li>
      </ul>
    </header>
  );
}
